export default __webpack_public_path__ + "static/pocketsprings-a79e695b4aa0958cfc86ca1fc7baab7a.jpg";